const ptBR = {
  metaTitle: 'Transporte Urbano em Tempo Real | WSJ Soluções Digitais',
  badge: 'Transporte Urbano em Tempo Real',
  heroTitle: 'Gestão de transporte urbano em tempo real.',
  heroSubtitle:
    'A WSJ desenvolve plataformas modernas para monitoramento, operação e experiência digital no transporte urbano.',
  heroBadges: [
    'Tempo real',
    'GPS',
    'Mobilidade urbana',
    'Gestão de frota',
    'Tracking',
    'Painel operacional',
    'ETA inteligente',
    'Dashboard'
  ],
  btnQuote: 'Solicitar proposta de parceria',
  btnWhatsapp: 'Falar sobre implantação',
  btnPlans: 'Ver modelo comercial',
  btnPartnershipProposal: 'Solicitar proposta de parceria',
  btnImplementation: 'Falar sobre implantação',
  btnStrategicMeeting: 'Agendar conversa estratégica',
  whatsappMessage: 'Olá! Gostaria de saber mais sobre a plataforma de transporte urbano em tempo real da WSJ.',

  sectionProblemsTitle: 'Problemas que a plataforma ajuda a resolver',
  sectionProblemsClose: 'A mobilidade moderna exige informação em tempo real e operação inteligente.',
  problemItems: [
    { title: 'Falta de previsibilidade', desc: 'Passageiros e operadores sem clareza sobre horários, atrasos e chegadas.' },
    { title: 'Passageiros sem informação', desc: 'Experiência limitada, sem dados úteis sobre linhas, veículos e ETA.' },
    { title: 'Operação desorganizada', desc: 'Controle fragmentado entre planilhas, rádio e processos manuais.' },
    { title: 'Controle manual de horários', desc: 'Dificuldade para ajustar, monitorar e comunicar mudanças operacionais.' },
    { title: 'Dificuldade de monitoramento', desc: 'Frota sem visibilidade centralizada de localização e status.' },
    { title: 'Falta de dados operacionais', desc: 'Decisões tomadas sem histórico, métricas ou indicadores confiáveis.' },
    { title: 'Comunicação limitada', desc: 'Pouca integração entre operadores, motoristas e passageiros.' },
    { title: 'Gestão urbana ineficiente', desc: 'Mobilidade sem base tecnológica para escalar e evoluir.' }
  ],

  sectionFeaturesTitle: 'Tecnologia aplicada ao transporte urbano',
  sectionFeaturesLead: 'Uma plataforma pensada para operação profissional, rastreamento e experiência digital.',
  features: [
    { title: 'Tracking em tempo real', desc: 'Localização contínua de veículos com atualização operacional.' },
    { title: 'ETA inteligente', desc: 'Estimativas de chegada baseadas em dados e contexto da operação.' },
    { title: 'Painel operacional', desc: 'Visão centralizada para monitorar frota, linhas e status.' },
    { title: 'Gestão de linhas', desc: 'Organização de rotas, paradas e configurações por operação.' },
    { title: 'Gestão de motoristas', desc: 'Controle operacional conforme escopo e regras do projeto.' },
    { title: 'Monitoramento GPS', desc: 'Integração com rastreamento para acompanhamento em mapa.' },
    { title: 'Alertas automáticos', desc: 'Notificações para eventos relevantes da operação.' },
    { title: 'Aplicativo mobile', desc: 'Experiência digital para passageiros ou operadores, conforme escopo.' },
    { title: 'Dashboard administrativo', desc: 'Painel para gestão, configuração e acompanhamento.' },
    { title: 'APIs e integrações', desc: 'Conexão com sistemas externos, mapas e serviços de terceiros.' },
    { title: 'Relatórios operacionais', desc: 'Histórico e indicadores para análise da operação.' },
    { title: 'Analytics de operação', desc: 'Métricas para entender desempenho, padrões e evolução.' }
  ],

  sectionProjectsTitle: 'Estrutura preparada para diferentes cidades',
  sectionProjectsLead:
    'Projetos preparados para expansão de soluções urbanas inteligentes em diferentes regiões.',
  sectionProjectsNote:
    'Ecossistema em evolução para mobilidade conectada. Alguns projetos estão em desenvolvimento ou estruturação — a WSJ não divulga números, contratos ou operação oficial sem confirmação.',
  projects: [
    {
      name: 'Braga Bus Express',
      city: 'Braga',
      desc: 'Estrutura preparada para soluções de mobilidade urbana conectada na região de Braga.',
      status: 'Em desenvolvimento'
    },
    {
      name: 'Lisboa Bus Express',
      city: 'Lisboa',
      desc: 'Projeto voltado a experiência digital e monitoramento para contexto urbano metropolitano.',
      status: 'Estrutura preparada'
    },
    {
      name: 'Porto Bus Express',
      city: 'Porto',
      desc: 'Base tecnológica pensada para operação, tracking e gestão de transporte urbano.',
      status: 'Estrutura preparada'
    },
    {
      name: 'Assis Bus',
      city: 'Assis',
      desc: 'Solução preparada para operadores locais com foco em informação e operação digital.',
      status: 'Em desenvolvimento'
    },
    {
      name: 'Tarumã Bus',
      city: 'Tarumã',
      desc: 'Projeto inserido no ecossistema WSJ de mobilidade com potencial de expansão regional.',
      status: 'Ecossistema em expansão'
    }
  ],
  projectStatusLabel: 'Status',

  sectionTechTitle: 'Infraestrutura moderna para operações em tempo real',
  sectionTechLead:
    'Arquitetura pensada para rastreamento, painéis, mobile e integrações — com base escalável e profissional.',
  techItems: [
    'GPS',
    'APIs',
    'Mobile',
    'Cloud',
    'Banco de dados',
    'Tracking',
    'Escalabilidade',
    'Tempo real',
    'Integrações'
  ],
  techNote:
    'Soluções em tempo real podem envolver infraestrutura cloud, APIs de mapas, GPS, servidores e serviços externos com custos variáveis conforme utilização.',

  sectionProcessTitle: 'Como funciona o processo',
  sectionProcessLead: 'Do entendimento da operação à evolução contínua — com transparência em cada etapa.',
  processSteps: [
    { title: 'Entendemos a operação', desc: 'Mapeamos frota, linhas, passageiros, operadores e objetivos reais.' },
    { title: 'Planejamos estrutura e rotas', desc: 'Definimos arquitetura, escopo, integrações e experiência digital.' },
    { title: 'Integramos tracking e dashboards', desc: 'GPS, mapas, painéis operacionais e base de dados em tempo real.' },
    { title: 'Configuramos aplicações e painéis', desc: 'Apps, alertas, relatórios e interfaces conforme operação.' },
    { title: 'Acompanhamos evolução da operação', desc: 'Ajustes, melhorias e suporte conforme escala e modelo de parceria acordado.' }
  ],

  sectionPartnershipTitle: 'Modelo comercial por parceria',
  sectionPartnershipLead:
    'Projetos de mobilidade urbana exigem análise técnica, operação local e alinhamento com prefeituras, investidores ou parceiros estratégicos. Por isso, a proposta é construída de forma personalizada para cada cidade.',
  partnershipModels: [
    {
      title: 'Parceria com Prefeitura',
      desc: 'Implantação da solução em conjunto com órgãos públicos, secretarias municipais ou programas de mobilidade urbana.'
    },
    {
      title: 'Investidor ou operador local',
      desc: 'Modelo para investidores, empresas ou operadores interessados em implementar a solução em uma cidade ou região.'
    },
    {
      title: 'Participação percentual',
      desc: 'Possibilidade de negociação por participação no projeto, receita operacional ou percentual acordado entre as partes.'
    },
    {
      title: 'Projeto sob consulta',
      desc: 'Cada implantação depende da cidade, volume estimado, operação, integrações, suporte e estratégia comercial.'
    }
  ],
  partnershipDisclaimer:
    'Não trabalhamos com preço fixo para este serviço. Cada projeto é avaliado individualmente conforme cidade, operação, investimento necessário e modelo de parceria.',

  sectionFaqTitle: 'Perguntas frequentes',
  sectionFaqLead: 'Transparência sobre implantação, parcerias e projetos de mobilidade urbana.',
  faqItems: [
    {
      q: 'O sistema funciona em tempo real?',
      a: 'Sim. A plataforma é projetada para rastreamento, monitoramento e atualização operacional em tempo real, conforme arquitetura e escopo definidos.'
    },
    {
      q: 'A plataforma possui aplicativo?',
      a: 'Sim. Conforme escopo e modelo de parceria, desenvolvemos aplicativos mobile para passageiros, operadores ou ambos.'
    },
    {
      q: 'É possível integrar GPS?',
      a: 'Sim. Integramos rastreamento GPS e serviços de localização conforme necessidade operacional e infraestrutura do projeto.'
    },
    {
      q: 'Funciona com múltiplas linhas?',
      a: 'Sim. A gestão de linhas, rotas e frota pode ser expandida conforme escala e complexidade acordadas no projeto.'
    },
    {
      q: 'Existe painel administrativo?',
      a: 'Sim. Incluímos painéis operacionais com profundidade e personalização definidas na proposta de parceria.'
    },
    {
      q: 'O sistema pode crescer para outras cidades?',
      a: 'Sim. A arquitetura é pensada para escalabilidade regional, permitindo expansão conforme operação e orçamento.'
    },
    {
      q: 'A infraestrutura cloud está incluída?',
      a: 'Não por padrão. Custos de cloud, servidores, APIs de mapas, GPS e serviços externos são definidos na proposta conforme operação e parceiros envolvidos.'
    },
    {
      q: 'Vocês desenvolvem soluções personalizadas?',
      a: 'Sim. Projetos de mobilidade urbana frequentemente exigem customização técnica conforme operação, frota e integrações.'
    },
    {
      q: 'Existe suporte contínuo?',
      a: 'Sim. Oferecemos suporte, evolução e acompanhamento conforme acordo de parceria e complexidade da operação.'
    },
    {
      q: 'Como funciona a proposta comercial?',
      a: 'Não há preço fixo publicado. Avaliamos cidade, operação, investimento e modelo de parceria (prefeitura, investidor ou participação percentual) para construir uma proposta personalizada.'
    }
  ],

  finalCtaTitle: 'Vamos estruturar a implantação na sua cidade?',
  finalCtaSubtitle:
    'Converse com a WSJ sobre parcerias com prefeituras, investidores ou operadores para projetos de mobilidade urbana inteligente.',

  heroMock: {
    mapLabel: 'Mapa em tempo real',
    dashboardLabel: 'Painel operacional',
    etaLabel: 'ETA estimado',
    gpsLabel: 'GPS ativo',
    liveTracking: 'Tracking ao vivo',
    mobileLabel: 'App mobile',
    analyticsLabel: 'Analytics operacional'
  }
};

const ptPT = {
  ...ptBR,
  metaTitle: 'Transporte Urbano em Tempo Real | WSJ Soluções Digitais',
  heroSubtitle:
    'A WSJ desenvolve plataformas modernas para monitorização, operação e experiência digital no transporte urbano.',
  heroBadges: [
    'Tempo real',
    'GPS',
    'Mobilidade urbana',
    'Gestão de frota',
    'Tracking',
    'Painel operacional',
    'ETA inteligente',
    'Dashboard'
  ],
  whatsappMessage: 'Olá! Gostaria de saber mais sobre a plataforma de transporte urbano em tempo real da WSJ.',

  btnQuote: 'Solicitar proposta de parceria',
  btnWhatsapp: 'Falar sobre implantação',
  btnPlans: 'Ver modelo comercial',
  btnPartnershipProposal: 'Solicitar proposta de parceria',
  btnImplementation: 'Falar sobre implantação',
  btnStrategicMeeting: 'Agendar conversa estratégica',

  sectionPartnershipTitle: 'Modelo comercial por parceria',
  sectionPartnershipLead:
    'Projetos de mobilidade urbana exigem análise técnica, operação local e alinhamento com autarquias, investidores ou parceiros estratégicos. Por isso, a proposta é construída de forma personalizada para cada cidade.',
  partnershipModels: [
    {
      title: 'Parceria com Autarquia',
      desc: 'Implantação da solução em conjunto com órgãos públicos, secretarias municipais ou programas de mobilidade urbana.'
    },
    {
      title: 'Investidor ou operador local',
      desc: 'Modelo para investidores, empresas ou operadores interessados em implementar a solução numa cidade ou região.'
    },
    {
      title: 'Participação percentual',
      desc: 'Possibilidade de negociação por participação no projeto, receita operacional ou percentagem acordada entre as partes.'
    },
    {
      title: 'Projeto sob consulta',
      desc: 'Cada implantação depende da cidade, volume estimado, operação, integrações, suporte e estratégia comercial.'
    }
  ],
  partnershipDisclaimer:
    'Não trabalhamos com preço fixo para este serviço. Cada projeto é avaliado individualmente conforme cidade, operação, investimento necessário e modelo de parceria.',

  sectionProblemsClose: 'A mobilidade moderna exige informação em tempo real e operação inteligente.',
  problemItems: [
    { title: 'Falta de previsibilidade', desc: 'Passageiros e operadores sem clareza sobre horários, atrasos e chegadas.' },
    { title: 'Passageiros sem informação', desc: 'Experiência limitada, sem dados úteis sobre linhas, veículos e ETA.' },
    { title: 'Operação desorganizada', desc: 'Controlo fragmentado entre folhas de cálculo, rádio e processos manuais.' },
    { title: 'Controlo manual de horários', desc: 'Dificuldade para ajustar, monitorizar e comunicar mudanças operacionais.' },
    { title: 'Dificuldade de monitorização', desc: 'Frota sem visibilidade centralizada de localização e estado.' },
    { title: 'Falta de dados operacionais', desc: 'Decisões tomadas sem histórico, métricas ou indicadores fiáveis.' },
    { title: 'Comunicação limitada', desc: 'Pouca integração entre operadores, motoristas e passageiros.' },
    { title: 'Gestão urbana ineficiente', desc: 'Mobilidade sem base tecnológica para escalar e evoluir.' }
  ],

  sectionFeaturesLead: 'Uma plataforma pensada para operação profissional, rastreamento e experiência digital.',
  features: [
    { title: 'Tracking em tempo real', desc: 'Localização contínua de veículos com atualização operacional.' },
    { title: 'ETA inteligente', desc: 'Estimativas de chegada baseadas em dados e contexto da operação.' },
    { title: 'Painel operacional', desc: 'Visão centralizada para monitorizar frota, linhas e estado.' },
    { title: 'Gestão de linhas', desc: 'Organização de rotas, paragens e configurações por operação.' },
    { title: 'Gestão de motoristas', desc: 'Controlo operacional conforme âmbito e regras do projeto.' },
    { title: 'Monitorização GPS', desc: 'Integração com rastreamento para acompanhamento em mapa.' },
    { title: 'Alertas automáticos', desc: 'Notificações para eventos relevantes da operação.' },
    { title: 'Aplicação mobile', desc: 'Experiência digital para passageiros ou operadores, conforme âmbito.' },
    { title: 'Dashboard administrativo', desc: 'Painel para gestão, configuração e acompanhamento.' },
    { title: 'APIs e integrações', desc: 'Ligação com sistemas externos, mapas e serviços de terceiros.' },
    { title: 'Relatórios operacionais', desc: 'Histórico e indicadores para análise da operação.' },
    { title: 'Analytics de operação', desc: 'Métricas para entender desempenho, padrões e evolução.' }
  ],

  sectionProjectsNote:
    'Ecossistema em evolução para mobilidade conectada. Alguns projetos estão em desenvolvimento ou estruturação — a WSJ não divulga números, contratos ou operação oficial sem confirmação.',
  projects: [
    { name: 'Braga Bus Express', city: 'Braga', desc: 'Estrutura preparada para soluções de mobilidade urbana conectada na região de Braga.', status: 'Em desenvolvimento' },
    { name: 'Lisboa Bus Express', city: 'Lisboa', desc: 'Projeto voltado a experiência digital e monitorização para contexto urbano metropolitano.', status: 'Estrutura preparada' },
    { name: 'Porto Bus Express', city: 'Porto', desc: 'Base tecnológica pensada para operação, tracking e gestão de transporte urbano.', status: 'Estrutura preparada' },
    { name: 'Assis Bus', city: 'Assis', desc: 'Solução preparada para operadores locais com foco em informação e operação digital.', status: 'Em desenvolvimento' },
    { name: 'Tarumã Bus', city: 'Tarumã', desc: 'Projeto inserido no ecossistema WSJ de mobilidade com potencial de expansão regional.', status: 'Ecossistema em expansão' }
  ],

  techItems: ['GPS', 'APIs', 'Mobile', 'Cloud', 'Base de dados', 'Tracking', 'Escalabilidade', 'Tempo real', 'Integrações'],
  techNote:
    'Soluções em tempo real podem envolver infraestrutura cloud, APIs de mapas, GPS, servidores e serviços externos com custos variáveis conforme utilização.',

  sectionProcessLead: 'Do entendimento da operação à evolução contínua — com transparência em cada etapa.',
  processSteps: [
    { title: 'Compreendemos a operação', desc: 'Mapeamos frota, linhas, passageiros, operadores e objetivos reais.' },
    { title: 'Planeamos estrutura e rotas', desc: 'Definimos arquitetura, âmbito, integrações e experiência digital.' },
    { title: 'Integramos tracking e dashboards', desc: 'GPS, mapas, painéis operacionais e base de dados em tempo real.' },
    { title: 'Configuramos aplicações e painéis', desc: 'Apps, alertas, relatórios e interfaces conforme operação.' },
    { title: 'Acompanhamos evolução da operação', desc: 'Ajustes, melhorias e suporte conforme escala e modelo de parceria acordado.' }
  ],

  faqItems: [
    { q: 'O sistema funciona em tempo real?', a: 'Sim. A plataforma é projetada para rastreamento, monitorização e atualização operacional em tempo real, conforme arquitetura e âmbito definidos.' },
    { q: 'A plataforma possui aplicação?', a: 'Sim. Conforme âmbito e modelo de parceria, desenvolvemos aplicações mobile para passageiros, operadores ou ambos.' },
    { q: 'É possível integrar GPS?', a: 'Sim. Integramos rastreamento GPS e serviços de localização conforme necessidade operacional e infraestrutura do projeto.' },
    { q: 'Funciona com múltiplas linhas?', a: 'Sim. A gestão de linhas, rotas e frota pode ser expandida conforme escala e complexidade acordadas no projeto.' },
    { q: 'Existe painel administrativo?', a: 'Sim. Incluímos painéis operacionais com profundidade e personalização definidas na proposta de parceria.' },
    { q: 'O sistema pode crescer para outras cidades?', a: 'Sim. A arquitetura é pensada para escalabilidade regional, permitindo expansão conforme operação e orçamento.' },
    { q: 'A infraestrutura cloud está incluída?', a: 'Não por defeito. Custos de cloud, servidores, APIs de mapas, GPS e serviços externos são definidos na proposta conforme operação e parceiros envolvidos.' },
    { q: 'Desenvolvem soluções personalizadas?', a: 'Sim. Projetos de mobilidade urbana frequentemente exigem customização técnica conforme operação, frota e integrações.' },
    { q: 'Existe suporte contínuo?', a: 'Sim. Oferecemos suporte, evolução e acompanhamento conforme acordo de parceria e complexidade da operação.' },
    { q: 'Como funciona a proposta comercial?', a: 'Não há preço fixo publicado. Avaliamos cidade, operação, investimento e modelo de parceria (autarquia, investidor ou participação percentual) para construir uma proposta personalizada.' }
  ],

  finalCtaTitle: 'Vamos estruturar a implantação na sua cidade?',
  finalCtaSubtitle:
    'Fale com a WSJ sobre parcerias com autarquias, investidores ou operadores para projetos de mobilidade urbana inteligente.'
};

const enUS = {
  metaTitle: 'Real-time Urban Transport | WSJ Soluções Digitais',
  badge: 'Real-time Urban Transport',
  heroTitle: 'Real-time urban transport management.',
  heroSubtitle:
    'WSJ builds modern platforms for monitoring, operations and digital experience in urban transport.',
  heroBadges: [
    'Real-time',
    'GPS',
    'Urban mobility',
    'Fleet management',
    'Tracking',
    'Operations panel',
    'Smart ETA',
    'Dashboard'
  ],
  btnQuote: 'Request a partnership proposal',
  btnWhatsapp: 'Discuss implementation',
  btnPlans: 'View commercial model',
  btnPartnershipProposal: 'Request a partnership proposal',
  btnImplementation: 'Discuss implementation',
  btnStrategicMeeting: 'Schedule a strategic call',
  whatsappMessage: 'Hello! I would like to know more about WSJ real-time urban transport platform.',

  sectionProblemsTitle: 'Problems the platform helps solve',
  sectionProblemsClose: 'Modern mobility requires real-time information and intelligent operations.',
  problemItems: [
    { title: 'Lack of predictability', desc: 'Passengers and operators without clarity on schedules, delays and arrivals.' },
    { title: 'Uninformed passengers', desc: 'Limited experience without useful data on lines, vehicles and ETA.' },
    { title: 'Disorganised operations', desc: 'Fragmented control across spreadsheets, radio and manual processes.' },
    { title: 'Manual schedule control', desc: 'Difficulty adjusting, monitoring and communicating operational changes.' },
    { title: 'Monitoring challenges', desc: 'Fleet without centralised location and status visibility.' },
    { title: 'Lack of operational data', desc: 'Decisions made without reliable history, metrics or indicators.' },
    { title: 'Limited communication', desc: 'Poor integration between operators, drivers and passengers.' },
    { title: 'Inefficient urban management', desc: 'Mobility without a technology base to scale and evolve.' }
  ],

  sectionFeaturesTitle: 'Technology applied to urban transport',
  sectionFeaturesLead: 'A platform designed for professional operations, tracking and digital experience.',
  features: [
    { title: 'Real-time tracking', desc: 'Continuous vehicle location with operational updates.' },
    { title: 'Smart ETA', desc: 'Arrival estimates based on data and operational context.' },
    { title: 'Operations panel', desc: 'Centralised view to monitor fleet, lines and status.' },
    { title: 'Line management', desc: 'Organisation of routes, stops and settings per operation.' },
    { title: 'Driver management', desc: 'Operational control according to project scope and rules.' },
    { title: 'GPS monitoring', desc: 'Tracking integration for map-based follow-up.' },
    { title: 'Automatic alerts', desc: 'Notifications for relevant operational events.' },
    { title: 'Mobile app', desc: 'Digital experience for passengers or operators, according to scope.' },
    { title: 'Admin dashboard', desc: 'Panel for management, configuration and monitoring.' },
    { title: 'APIs & integrations', desc: 'Connection with external systems, maps and third-party services.' },
    { title: 'Operational reports', desc: 'History and indicators for operation analysis.' },
    { title: 'Operation analytics', desc: 'Metrics to understand performance, patterns and evolution.' }
  ],

  sectionProjectsTitle: 'Structure prepared for different cities',
  sectionProjectsLead: 'Projects prepared for expansion of smart urban solutions across different regions.',
  sectionProjectsNote:
    'Evolving ecosystem for connected mobility. Some projects are in development or structuring — WSJ does not disclose numbers, contracts or official operations without confirmation.',
  projects: [
    { name: 'Braga Bus Express', city: 'Braga', desc: 'Structure prepared for connected urban mobility solutions in the Braga region.', status: 'In development' },
    { name: 'Lisboa Bus Express', city: 'Lisboa', desc: 'Project focused on digital experience and monitoring for metropolitan urban context.', status: 'Structure prepared' },
    { name: 'Porto Bus Express', city: 'Porto', desc: 'Technology base designed for operations, tracking and urban transport management.', status: 'Structure prepared' },
    { name: 'Assis Bus', city: 'Assis', desc: 'Solution prepared for local operators with focus on information and digital operations.', status: 'In development' },
    { name: 'Tarumã Bus', city: 'Tarumã', desc: 'Project within WSJ mobility ecosystem with regional expansion potential.', status: 'Expanding ecosystem' }
  ],
  projectStatusLabel: 'Status',

  sectionTechTitle: 'Modern infrastructure for real-time operations',
  sectionTechLead: 'Architecture designed for tracking, panels, mobile and integrations — scalable and professional.',
  techItems: ['GPS', 'APIs', 'Mobile', 'Cloud', 'Database', 'Tracking', 'Scalability', 'Real-time', 'Integrations'],
  techNote:
    'Real-time solutions may involve cloud infrastructure, map APIs, GPS, servers and external services with variable costs depending on usage.',

  sectionProcessTitle: 'How the process works',
  sectionProcessLead: 'From understanding operations to continuous evolution — with transparency at every stage.',
  processSteps: [
    { title: 'We understand the operation', desc: 'We map fleet, lines, passengers, operators and real goals.' },
    { title: 'We plan structure and routes', desc: 'We define architecture, scope, integrations and digital experience.' },
    { title: 'We integrate tracking and dashboards', desc: 'GPS, maps, operational panels and real-time database.' },
    { title: 'We configure apps and panels', desc: 'Apps, alerts, reports and interfaces according to operation.' },
    { title: 'We monitor operation evolution', desc: 'Adjustments, improvements and support according to scale and agreed partnership model.' }
  ],

  sectionPartnershipTitle: 'Partnership commercial model',
  sectionPartnershipLead:
    'Urban mobility projects require technical analysis, local operations and alignment with municipalities, investors or strategic partners. Each proposal is built individually for each city.',
  partnershipModels: [
    {
      title: 'Municipal partnership',
      desc: 'Solution deployment together with public bodies, city departments or urban mobility programmes.'
    },
    {
      title: 'Investor or local operator',
      desc: 'Model for investors, companies or operators interested in implementing the solution in a city or region.'
    },
    {
      title: 'Revenue share',
      desc: 'Negotiation through project participation, operational revenue or an agreed percentage between parties.'
    },
    {
      title: 'Custom project',
      desc: 'Each deployment depends on the city, estimated volume, operations, integrations, support and commercial strategy.'
    }
  ],
  partnershipDisclaimer:
    'We do not use fixed pricing for this service. Each project is assessed individually according to city, operations, required investment and partnership model.',

  sectionFaqTitle: 'FAQ',
  sectionFaqLead: 'Transparency about deployment, partnerships and urban mobility projects.',
  faqItems: [
    { q: 'Does the system work in real time?', a: 'Yes. The platform is designed for tracking, monitoring and real-time operational updates, according to defined architecture and scope.' },
    { q: 'Does the platform have a mobile app?', a: 'Yes. According to scope and partnership model, we build mobile apps for passengers, operators or both.' },
    { q: 'Can GPS be integrated?', a: 'Yes. We integrate GPS tracking and location services according to operational needs and project infrastructure.' },
    { q: 'Does it work with multiple lines?', a: 'Yes. Line, route and fleet management can expand with scale and complexity agreed in the project.' },
    { q: 'Is there an admin dashboard?', a: 'Yes. We include operational panels with depth and customisation defined in the partnership proposal.' },
    { q: 'Can the system grow to other cities?', a: 'Yes. Architecture is designed for regional scalability, allowing expansion according to operation and budget.' },
    { q: 'Is cloud infrastructure included?', a: 'Not by default. Cloud, server, map API, GPS and external service costs are defined in the proposal according to operation and partners involved.' },
    { q: 'Do you build custom solutions?', a: 'Yes. Urban mobility projects often require technical customisation according to operation, fleet and integrations.' },
    { q: 'Is there ongoing support?', a: 'Yes. We offer support, evolution and follow-up according to the partnership agreement and operation complexity.' },
    { q: 'How does the commercial proposal work?', a: 'There is no published fixed price. We assess city, operations, investment and partnership model (municipality, investor or revenue share) to build a tailored proposal.' }
  ],

  finalCtaTitle: 'Ready to structure deployment in your city?',
  finalCtaSubtitle:
    'Talk to WSJ about partnerships with municipalities, investors or operators for smart urban mobility projects.',

  heroMock: {
    mapLabel: 'Real-time map',
    dashboardLabel: 'Operations panel',
    etaLabel: 'Estimated ETA',
    gpsLabel: 'GPS active',
    liveTracking: 'Live tracking',
    mobileLabel: 'Mobile app',
    analyticsLabel: 'Operational analytics'
  }
};

const fallbackLocales = ['es', 'fr', 'it', 'hi', 'de', 'nl', 'ru', 'ar', 'zh-CN', 'zh-TW'];

export const urbanTransportPageByLang = {
  'pt-BR': ptBR,
  'pt-PT': ptPT,
  en: enUS,
  ...Object.fromEntries(fallbackLocales.map((code) => [code, enUS]))
};
